<template>
  <div class="package-and-service">
    <slot name="header" />
    
    <template v-for="(product, index) in productList">
      <div
        class="text-box service-box"
        :key="index"
        v-if="!productDisabled(product.service_list)"
      >
        <div class="text-item">
          <div
            class="text-label"
            v-t="'order.aliOrderLine'"
          />
          <div class="text-value">
            {{ product.ali_order_product_id }}
          </div>
        </div>
        <div
          v-if="product.enable_business_group"
          class="text-item"
        >
          <div class="text-label">
            {{ $t('product.siteName') }}
          </div>
          <div class="text-value">
            {{ product.business_name }}
          </div>
        </div>
        <div class="text-item">
          <div
            class="text-label"
            v-t="'product.name'"
          />
          <div class="text-value">
            {{ product.version_name }}
            <span v-if="product.type == ORDER_TYPE_APPEND && product.refer_ids_info.length">
              （
              {{ $t('product.oriDate') }}
              {{ product.refer_ids_info[0].valid_from | dateFormat }}
              {{ $t('service.to') }}
              {{ product.refer_ids_info[0].valid_to | dateFormat }}
              ）
            </span>
          </div>
        </div>
        <div class="text-item">
          <div
            class="text-label"
            v-t="'product.type'"
          />
          <div class="text-value">
            {{ product.type_name }}
          </div>
        </div>
        <!-- 产品服务 -->
        <component
          :is="serviceCom(product)"
          :data="product"
        />
        <div class="text-origin">
          {{ $t('order.originAmount') }}：{{ currency }}{{ product.original_amount }}
        </div>
        <!-- 已支付订单行不显示小计 -->
        <div 
          class="text-total" 
          v-if="Number(detail.status) !== ORDER_STATUS_COMPLETE"
        >
          {{ $t('order.subTotal') }}：{{ currency }}{{ product.amount }}
        </div>
        <!-- 已支付订单行显示已付、已退款 -->
        <template v-if="Number(detail.status) === ORDER_STATUS_COMPLETE">
          <div class="text-paid">
            {{ `${$t('order.alreadyPaid')}：${currency}${product.amount} (${$t('order.transferIn')}：${currency}${product.transfer_in_amount})` }}
          </div>
          <div class="text-refund">
            {{ `${$t('order.refund')}：${currency}${product.refund_amount}` }}
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import {
    ORDER_TYPE_NEW,
    ORDER_TYPE_APPEND,
    ORDER_TYPE_RENEW,
    ORDER_TYPE_UPGRADE,
    ORDER_TYPE_MAIN,
    ORDER_TYPE_TRANSFER,
    ORDER_TYPE_CHANGE_RENEW,
    ORDER_TYPE_PROMOTION_RENEW,
    SERVICE_ID_GOOGLE_CID,
    ORDER_STATUS_COMPLETE
  } from '@utils/constants'
  
  import RenderService from './ServiceStrategy/RenderService'
  import RenderContract from './ServiceStrategy/RenderContract'

  export default {
    name: 'PackageAndService',
    props: {
      productList: {
        required: true,
        type: Array,
      }
    },
    data() {
      return {
        ORDER_TYPE_APPEND,
        ORDER_STATUS_COMPLETE,
      }
    },
    computed: {
      ...mapGetters('order', ['currency']),
      ...mapState('order', {
        detail: state => state.detail,
      }),
    },
    methods: {
      serviceCom (product) {
        const comMap = {
          [ORDER_TYPE_NEW]: RenderService,
          [ORDER_TYPE_APPEND]: RenderService,
          [ORDER_TYPE_RENEW]: RenderService,
          [ORDER_TYPE_UPGRADE]: RenderContract,
          [ORDER_TYPE_CHANGE_RENEW]: RenderService,
          [ORDER_TYPE_PROMOTION_RENEW]: RenderService,
          [ORDER_TYPE_MAIN]: RenderService,
          [ORDER_TYPE_TRANSFER]: RenderService,
        }
        return comMap[product.type]
      },
      productDisabled(service) {
        return (
          service.length === 1 &&
          service[0].service_id == SERVICE_ID_GOOGLE_CID &&
          Number(service[0].text) == 0
        );
      }
    }
  }
</script>
<style lang="scss">
  .detail-container {
    .package-and-service {
      padding-top: 20px;
      border-top: 2px solid #D9D9D9;
    }
  }
  .service-box{
    padding-bottom: 20px;
    &:nth-child(n+3){
      border-top: 1px solid #D9D9D9;
    }
  }
  .text{
    &-box{
      display: flex;
      flex-direction: column;
      padding-top: 20px;
      padding-bottom: 8px;
      line-height: 1;
    }
    &-item{
      display: flex;
      align-items: flex-start;
    }
    &-label{
      min-width: 150px;
      height: 30px;
      color: #7F878F;
    }
    &-value{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 20px;
      font-weight: 600;
      color: #3A444A;
      &-contract{
        flex: 0 0 100%;
      }
      @include layout--mobile{
        padding-left: 1em;      
      }
    }
    &-total{
      font-weight: 600;
      line-height: 2;
      color: $base-color;
      text-align: right;
    }
    &-origin{
      font-weight: 600;
      line-height: 2;
      color: #3A444A;
      text-align: right;
    }
    &-paid{
      font-weight: 600;
      line-height: 2;
      color: $base-color;
      text-align: right;
    }
    &-refund{
      font-weight: 600;
      line-height: 2;
      color: #3A444A;
      text-align: right;
    }
  }
</style>

